<template>
  <div>
    <div class="recommend-wrapper">

      <div class="module" v-if="suggestions && suggestions.length>0">
        <div class="module-title">生活方式建议</div>
        <div class="suggestion-wrapper">
          <div class="suggestion-row" v-for="(sugg,index) in suggestions">
            <div class="suggestion-icon">
              <img :src="sugg.icon" class="" />
            </div>
            <div class="suggestion-detail">
              <div class="suggestion-title">{{sugg.title}}</div>
              <div class="suggestion-text">{{sugg.content}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="module">
        <div class="module-title">推荐体检方案</div>
        <div class="package-wrapper">
          <div v-for="(pkg) in projects" :key="pkg.packageId" @click="setProject(pkg)">
            <div class="package-header">{{pkg.packageName}}</div>
            <div class="package-row">
              <!-- <router-link to="/packageDetail" class="package-row"> -->
              <div class="package-img"></div>
              <div class="package-info">
                <div class="package-desc">{{pkg.addItemsName}}</div>
                <div class="package-footer">
                  <div class="package-price">￥{{pkg.packagePrice}}</div>
                  <div class="package-order-count">{{pkg.packageAppointCount}}人已预约</div>
                </div>
              </div>
              <!-- </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="recommend-empty"></div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        recommandPackages: [],
        projects: [],
        suggestions: null,
      };
    },
    mounted() {
      if (sessionStorage.getItem("customizedProjects")) {
        this.projects = JSON.parse(sessionStorage.getItem("customizedProjects"));
        if (this.projects && this.projects.length > 0) {
          this.projects.forEach(proj => {
            var addItems = proj.addItems;
            if (addItems && addItems.length > 0) {
              proj.addItemsName = '推荐加项：' + addItems.map(x => {
                return x.name
              }).join();
            } else {
              proj.addItemsName = "";
            }
          });
        }
      }
      //202407 瑞金医院增加健康建议
      if (sessionStorage.getItem("suggestions")) {
        let list = JSON.parse(sessionStorage.getItem("suggestions"));
        this.suggestions = [];
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          if (item.suggestionType == 'foods') {
            this.suggestions.push({
              icon: require("../../assets/images/icon-foods.png"),
              title: '饮食',
              content: item.suggestionText,
            })
          } else if (item.suggestionType == 'sports') {
            this.suggestions.push({
              icon: require("../../assets/images/icon-sports.png"),
              title: '运动',
              content: item.suggestionText,
            })
          } else if (item.suggestionType == 'drinking') {
            this.suggestions.push({
              icon: require("../../assets/images/icon-drinking.png"),
              title: '饮酒',
              content: item.suggestionText,
            })
          } else if (item.suggestionType == 'smoking') {
            this.suggestions.push({
              icon: require("../../assets/images/icon-smoking.png"),
              title: '吸烟',
              content: item.suggestionText,
            })
          }
        }
      }
    },
    methods: {
      setProject(project) {
        sessionStorage.setItem("customize-project", JSON.stringify(project))
        this.$router.push('/survey/project')
      }
    },
  };
</script>


<style lang="less" scoped>
  .price {
    color: var(--color-price);
  }

  .recommend-wrapper {}

  .module {
    margin: 12px;
    background: #ffffff;
    border-radius: 8px;
    padding: 10px;

    .module-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 32px;
      display: block;
      text-align: center;
      position: relative;
      margin: auto;
      z-index: 2;
    }

    .module-title:after {
      content: " ";
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 4px;
      height: 8px;
      width: 50px;
      border-radius: 4px;
      background-color: #81bcf74f;
      z-index: 1;
    }
  }

  .suggestion-row {
    display: flex;
    margin-bottom: 12px;

    .suggestion-icon {
      margin: 0 24px;
      padding-top: 46px;

      img {
        width: 36px;
        height: 36px;
      }
    }

    .suggestion-detail {
      .suggestion-title {
        line-height: 46px;
        font-size: 18px;
        font-weight: 600;
      }

      .suggestion-text {
        font-size: 13px;
        color: #7e7e7e;
      }
    }
  }

  .package-wrapper {
    .package-header {
      padding: 16px 8px 0px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .package-row {
      display: flex;
      padding: 10px 8px;
      border-bottom: 1px solid #f2f2f2;

      .package-img {
        margin-right: 20px;
        width: 120px;
        height: 80px;
        border-radius: 10px;
        background: #eeeeee;
        background-image: url('../../assets/images/doctor-discuss.jpg');
        background-size: cover;
      }

      .package-info {
        flex: 1;

        .package-desc {
          font-size: 13px;
          color: #666666;
        }

        .package-footer {
          margin-top: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          justify-items: center;

          .package-order-count {
            font-size: 13px;
            color: #666666;
          }

          .package-price {
            flex: 1;
            color: var(--color-price);
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
          }

          .package-price:first-letter {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>